export default __webpack_public_path__ + "static/subscribe-content-illustration-light-a257e08449cdca27cec636b46092c4d7.svg";